<template>
  <BaseButton
    v-bind="$attrs"
    background-colour="white"
  >
    <template #content>
      <slot />
    </template>
  </BaseButton>
</template>
